import config from "../config";

const baseURL = config.baseURL;

const fetchConfig = async (basePath, method = "GET", params = null, payload = null) => {
    const path = `${baseURL}${basePath}`;
    console.log("fetchConfig called with:", { path, method, params, payload }); 

    const queryString = params
        ? new URLSearchParams(params).toString()
        : "";

    const url = `${path}${queryString ? `?${decodeURIComponent(queryString)}` : ""}`;

    const headers = {
        "Content-Type": "application/json",
        "Authorization": localStorage.getItem("access_token") || "",
    };

    try {
        const response = await fetch(url, {
            method,
            headers,
            ...(method !== "GET" && {
                body: JSON.stringify(payload),
            }),
        });

        if (!response.ok) {
            if (response.status === 401) {
                console.log("Unauthorized! Redirecting to login...");
                localStorage.removeItem("access_token");
                window.location.href = "/login";
            }

            let errorData = null;

            try {
                errorData = await response.json();
            } catch (e) {
                errorData = await response.text();
            }

            throw {
                status: response.status,
                data: errorData,
            };
        }

        return await response.json();
    } catch (error) {
        console.error("Fetch Error:", error);
        throw error;
    }
};

export const getAgencyPerformance = (data = {}) => {
    const today = new Date();

    const params = {
        slab:
            data.slab ||
            `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`,
    };

    if (data.agency_id) {
        params.agency_id = data.agency_id.join(",");
    }

    return fetchConfig("collections-v2/get_performance", "GET", params);
};

export const getUserSettlementEmail = (student_id) => {
    console.log("student id : ", student_id);
    if (!student_id) {
        return Promise.reject("No student id found");
    }

    return fetchConfig("collections-v1/get_settlement_email", "GET", {
        student_id,
    });
};

export const updateUserSettlementEmail = (student_id, email) => {
    if (!student_id) {
        return Promise.reject("No student id found");
    }

    return fetchConfig(
        "collections-v1/change_settlement_email",
        "POST",
        null,
        {
            student_cog_id: student_id,
            email,
        }
    );
};

export const getSettlementPaymentOptions = () => {
    return fetchConfig(
        "collections-v1/get_settlement_options",
        "GET"
    );
};

export const switcchSettlementPayment = (mode) => {
    return fetchConfig(
        "collections-v1/switch_settlement_payment",
        "GET",
        { mode }
    );
};